function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["className", "clickableAttribute", "dataTestId", "disabled", "error", "inputClassName", "inputRef", "inputWidth", "integer", "isAssertiveError", "label", "marginBottom", "marginLeft", "marginRight", "marginTop", "name", "onKeyPress", "onPaste", "optional", "showCurrencySymbol", "supportiveText", "tooltip", "valid"];
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import classnames from 'classnames';
import React, { forwardRef, useCallback, useMemo } from 'react';
import { useTheme } from 'styled-components';
import StyledCurrencyFieldContainer, { StyledCurrencyFieldSymbol } from "./styled";
import BackgroundProvider from "../BackgroundProvider";
import { useBrand } from "../BrandProvider";
import LabeledField from "../LabeledField";
import Text from "../Text";
import TextInput from "../TextInput";
import { dataAndRest, getResponsiveValue, specificDataAndRest, useDataQaId } from "../../utils";
/**
 * Documentation:
 *
 * - [Link for Windows (On-prem)](https://pages.ghe.service.group/constellation/docs/components/currency-field)
 **/
var CurrencyField = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var className = _ref.className,
    clickableAttribute = _ref.clickableAttribute,
    dataTestId = _ref.dataTestId,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    error = _ref.error,
    inputClassName = _ref.inputClassName,
    inputRef = _ref.inputRef,
    _ref$inputWidth = _ref.inputWidth,
    inputWidth = _ref$inputWidth === void 0 ? 'default' : _ref$inputWidth,
    _ref$integer = _ref.integer,
    integer = _ref$integer === void 0 ? false : _ref$integer,
    isAssertiveError = _ref.isAssertiveError,
    label = _ref.label,
    marginBottom = _ref.marginBottom,
    marginLeft = _ref.marginLeft,
    marginRight = _ref.marginRight,
    marginTop = _ref.marginTop,
    name = _ref.name,
    onKeyPress = _ref.onKeyPress,
    onPaste = _ref.onPaste,
    _ref$optional = _ref.optional,
    optional = _ref$optional === void 0 ? false : _ref$optional,
    _ref$showCurrencySymb = _ref.showCurrencySymbol,
    showCurrencySymbol = _ref$showCurrencySymb === void 0 ? true : _ref$showCurrencySymb,
    supportiveText = _ref.supportiveText,
    tooltip = _ref.tooltip,
    valid = _ref.valid,
    rest = _objectWithoutProperties(_ref, _excluded);
  var theme = useTheme();
  var _ref2 = useBrand() || {},
    _ref2$testAttributeNa = _ref2.testAttributeName,
    testAttributeName = _ref2$testAttributeNa === void 0 ? 'data-qa-id' : _ref2$testAttributeNa;
  var testAttributes;
  var finalDataTestId = useDataQaId(_objectSpread({
    dataTestId: dataTestId
  }, rest));
  var getTestAttributes = function getTestAttributes(element) {
    var _testAttributes;
    return ((_testAttributes = testAttributes) === null || _testAttributes === void 0 ? void 0 : _testAttributes[element]) || {};
  };
  if (finalDataTestId) {
    testAttributes = {};
    testAttributes.input = _defineProperty({}, testAttributeName, "".concat(finalDataTestId, "-input"));
  }
  var shouldPreventInput = function shouldPreventInput(potentialNewValue, event) {
    var _potentialNewValue$sp;
    var potentialNewNumberValue = Number(potentialNewValue);
    var wouldBeNaN = isNaN(potentialNewNumberValue) || Boolean(!potentialNewValue.match(/^[0-9.]+$/));
    var isOverTwoDecimalPlaces = ((_potentialNewValue$sp = potentialNewValue.split('.')[1]) === null || _potentialNewValue$sp === void 0 ? void 0 : _potentialNewValue$sp.length) > 2;
    var isInteger = String(potentialNewValue).length === potentialNewNumberValue.toFixed(0).length;
    var keyboard = event ? event.which : event.keyCode;
    var avoidSpace = keyboard === 32;
    if (wouldBeNaN || isOverTwoDecimalPlaces || integer && !isInteger || avoidSpace || potentialNewValue < 0) {
      event.preventDefault();
    }
  };
  var handleKeyPress = function handleKeyPress(event) {
    for (var _len = arguments.length, keyPressRest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      keyPressRest[_key - 1] = arguments[_key];
    }
    if (typeof onKeyPress === 'function') return onKeyPress.apply(void 0, [event].concat(keyPressRest));
    var _event$target = event.target,
      value = _event$target.value,
      selectionStart = _event$target.selectionStart,
      selectionEnd = _event$target.selectionEnd;
    var charCode = event.charCode,
      key = event.key;
    // Support for NumPad and IE11
    var inputChar = charCode === 46 ? '.' : key;
    shouldPreventInput("".concat(value.slice(0, selectionStart)).concat(inputChar).concat(value.slice(selectionEnd, value.length)), event);
  };
  var handlePaste = function handlePaste(event) {
    for (var _len2 = arguments.length, pasteRest = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      pasteRest[_key2 - 1] = arguments[_key2];
    }
    if (typeof onPaste === 'function') return onPaste.apply(void 0, [event].concat(pasteRest));
    shouldPreventInput(event.clipboardData.getData('Text'), event);
  };
  var renderCurrencySymbol = useCallback(function () {
    var _theme$vars;
    if (!showCurrencySymbol) return null;
    return /*#__PURE__*/React.createElement(BackgroundProvider, {
      value: {
        cssValue: (_theme$vars = theme.vars) === null || _theme$vars === void 0 ? void 0 : _theme$vars.color_input_background_default
      }
    }, /*#__PURE__*/React.createElement(StyledCurrencyFieldSymbol, {
      className: "csl-currency-field__currency"
    }, /*#__PURE__*/React.createElement(Text, {
      size: "s2",
      weight: "bold"
    }, "\xA3")));
  }, [showCurrencySymbol]);
  var renderInputField = function renderInputField() {
    var inputClassNames = classnames('csl-currency-field__input', inputClassName, {
      'csl-currency-field__input--valid': !disabled && valid
    });
    var inputRest = _extends({}, inputAttributes);
    return /*#__PURE__*/React.createElement(StyledCurrencyFieldContainer, {
      $showCurrencySymbol: showCurrencySymbol,
      className: "csl-currency-field__container"
    }, /*#__PURE__*/React.createElement(TextInput, _extends({}, getTestAttributes('input'), inputRest, {
      "aria-describedby": "".concat(name, "-hint ").concat(name, "-error"),
      className: inputClassNames,
      disabled: disabled,
      error: Boolean(error),
      inputMode: rest.inputMode !== undefined ? rest.inputMode : integer ? 'numeric' : 'decimal',
      name: name,
      onKeyPress: handleKeyPress,
      onPaste: handlePaste,
      pattern: rest.pattern !== undefined ? rest.pattern : integer ? '[0-9]*' : undefined,
      ref: inputRef,
      required: !optional,
      type: "text",
      valid: valid,
      width: inputWidth
    })), renderCurrencySymbol());
  };
  var _dataAndRest = dataAndRest(rest),
    _dataAndRest2 = _slicedToArray(_dataAndRest, 2),
    dataAttributes = _dataAndRest2[0],
    restAttributes = _dataAndRest2[1];
  var _specificDataAndRest = specificDataAndRest(rest, clickableAttribute),
    _specificDataAndRest2 = _slicedToArray(_specificDataAndRest, 1),
    clickableAttributes = _specificDataAndRest2[0];
  var inputAttributes = _objectSpread(_objectSpread({}, restAttributes), clickableAttributes);
  var classNames = useMemo(function () {
    return classnames('csl-currency-field', className);
  }, [className]);
  return label !== undefined ? /*#__PURE__*/React.createElement(LabeledField, _extends({}, dataAttributes, {
    className: classNames,
    createChildProps: false,
    dataTestId: finalDataTestId,
    error: error,
    isAssertiveError: isAssertiveError,
    label: label,
    marginBottom: getResponsiveValue(marginBottom),
    marginLeft: getResponsiveValue(marginLeft),
    marginRight: getResponsiveValue(marginRight),
    marginTop: getResponsiveValue(marginTop),
    name: name,
    optional: optional,
    ref: ref,
    supportiveText: supportiveText,
    tooltip: tooltip
  }), renderInputField()) : /*#__PURE__*/React.createElement("div", {
    className: "csl-field-child"
  }, renderInputField());
});
CurrencyField.displayName = 'CurrencyField';
export default CurrencyField;